module.exports = __webpack_public_path__ + "static/softgels-61afe0eeb39cb31f6410b5be583f243f.png";